import { FilterAlt } from "@mui/icons-material";
import { Box, Drawer, IconButton, SxProps, Theme, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { GqlFilterOption } from "~/__generated__";

import GaiaActiveFilters from "../GaiaActiveFilters";
import GaiaFilterList from "../GaiaFilterList";

type Props = {
    filterOptions: GqlFilterOption[];
    filterModel?: Record<string, string>;
    onFilterModelChange: (key: string, value: string | null) => void;
    sx?: SxProps<Theme>;
};

export default function GaiaFilterHeader({ filterOptions, filterModel, onFilterModelChange, sx = undefined }: Props) {
    const { t } = useTranslation("app");
    const theme = useTheme();
    const isMdOrLarger = useMediaQuery(theme.breakpoints.up("md"));

    const [showFilterOptions, setShowFilterOptions] = useState(false);
    return (
        <>
            <Drawer open={showFilterOptions} onClose={() => setShowFilterOptions(false)} anchor="right">
                <Box sx={{ p: 2 }}>
                    <Typography variant="h4">{t("gaiaFilterHeader.drawerTitle")}</Typography>
                    <GaiaFilterList
                        filters={filterOptions}
                        direction="column"
                        onChange={onFilterModelChange}
                        values={filterModel}
                    />
                </Box>
            </Drawer>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    ...sx,
                }}
            >
                {!isMdOrLarger && filterOptions.length > 1 && (
                    <IconButton onClick={() => setShowFilterOptions(true)}>
                        <FilterAlt />
                    </IconButton>
                )}

                {isMdOrLarger || filterOptions.length < 2 ? (
                    <GaiaFilterList size="small" filters={filterOptions} onChange={onFilterModelChange} values={filterModel} />
                ) : (
                    <GaiaActiveFilters filterOptions={filterOptions} onChange={onFilterModelChange} values={filterModel} />
                )}
            </Box>
        </>
    );
}
